import { uploadFile } from '../api/uploadFile'

/**
 * 上传图片
 * @param {file} file 文件名
 * @param {obj} vm vue实例
 * @param {string} loadingText 上传中的文字
 */
export function uploadFileReq({ file, vm, loadingText }) {
  console.log(file)
  const formData = new FormData()
  formData.append('file', file)
  vm && vm.$toast.loading({
    message: loadingText,
    forbidClick: true,
    duration: 0
  })
  return uploadFile(formData).then(result => {
    vm && vm.$toast.clear()
    return result
  })
}
